import { render, staticRenderFns } from "./OpsBrandRename.vue?vue&type=template&id=08abb67a&"
import script from "./OpsBrandRename.vue?vue&type=script&lang=js&"
export * from "./OpsBrandRename.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports